import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/SelectedFacets/index.js";
const variants = import.meta.webpackContext("/components/SelectedFacets", { recursive: true, regExp: /\.\/__variants__\/plp\-filtering\-experience\/v2\/index\.js/ });
export default pointCut({ joinPoint, variants });